import React from 'react';
//import NotificationsObservable from '../../../../znotusedcurrently/rxjs/observables/NotificationsObservable';
//import MaterialUiNotificationsTable from '../../../../znotusedcurrently/notifications/MaterialUiNotificationsTable.jsx2';
import {observer} from "mobx-react-lite";
import {useWebsocketStore} from "../../../../stores/websocketStore/websocketProvider";

const DisplayNotifications = observer(({}) =>{
  const {notificationsStore} = useWebsocketStore();
  return <>{JSON.stringify(notificationsStore.notifications)}</>/*<MaterialUiNotificationsTable values={notificationsStore.notifications} />;*/
});

export default DisplayNotifications;
/*
export default class DisplayNotifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = { notifications: {} };
  }

  componentDidMount() {
    this.subscription = NotificationsObservable.subscribe(
      (notificationsPromise) => {
        notificationsPromise.then((notifications) =>
          this.setState({ notifications: notifications })
        );
      }
    );
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  render() {
    return <MaterialUiNotificationsTable values={this.state.notifications} />;
  }
}*/
